import React from "react";
import CompanyAvatar from "../Avatars/CompanyAvatar";
import "../../css/chats.css";
import { SingleMessageType } from "../../interfaces/chats";
import { getMessageTimestamp } from "../../functions/commons";
import { isEmpty } from "lodash";

interface FromMessagePropType {
  chat: SingleMessageType;
  profileImage: string;
}

function FromMessage(props: FromMessagePropType) {
  const { chat, profileImage } = props;
  return (
    <>
      <div className="r2cmc-to-and-from-msgs__from-msg-div">
        <div style={{ marginBottom: "5px" }}>
          <span>{getMessageTimestamp(chat.createdAt)}</span>
        </div>
        <div className="tafm-from-msg-div__img-msg">
          {!profileImage ? <CompanyAvatar /> : <img src={profileImage} />}

          <div className="message-content-details">
            <h5>{chat.content}</h5>
          </div>
        </div>
      </div>
    </>
  );
}

export default FromMessage;
